import { render, staticRenderFns } from "./DialogLoaderComponent.vue?vue&type=template&id=49b57fc8&"
import script from "./DialogLoaderComponent.vue?vue&type=script&lang=js&"
export * from "./DialogLoaderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/gabriel/Documents/Projetos/kenny_fontes/curso-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VDialog,VProgressLinear})
